import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import {
    alpha,
    Menu,
    MenuItem,
    Typography,
    Tooltip,
    withStyles
} from '@material-ui/core';
import { Link } from '@portal/arq-portal-core';

import { generarEnlaceGoogle, generarEnlaceYahoo, generarEnlaceIcs } from '../utils/calendar';
import { abrirDetachedWindow } from '../utils/enlace';

//Model
type EventTypes = {
    Titulo: string,
    DescripcionBreve: string,
    EnlaceEvento: string,
    FechaFin: string,
    FechaInicio: string,
    UrlBase: string,
    Destacada: Boolean,
    EventoDiario: Boolean
}

interface Event {
    event: EventTypes
}

const useStyles = makeStyles((theme) => ({
    itemEvent: {//more than 3 events
        transition: '.2s ease all',
        marginBottom: '7px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        position: 'relative',
        '& .item-event-date': {
            width: '55px',
            height: '55px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column',
            backgroundColor: '#fff',
            '& .event-month': {
                textTransform: 'uppercase',
                fontWeight: 'bold',
                fontSize: '14px',
                fontFamily: 'Catalana-Bold',
                marginBottom: '-1px',
            },
            '& .event-day': {
                fontWeight: 'bold',
                fontSize: '20px',
                fontFamily: 'Catalana-Bold',
            },
            '& .event-color': {
                color: '#DC0028',
            }
        },
        '& .item-event-content': {
            width: 'calc(100% - 70px)',
            height: '55px',
            paddingLeft: '1rem',
            boxSizing: 'border-box',
            flexDirection: 'column',
            alignItems: 'flex-start',
            justifyContent: 'space-between',
            paddingBottom: '4px',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            display: 'block',
            '& .wrapper': {
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                width: 'calc(100% - 0px)',
                display: 'block',
            },
            '& h3': {
                margin: 0,
                fontSize: '14px',
                paddingTop: '2px',
                paddingBottom: '2px',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                width: 'calc(100% - 22px)',
                display: 'block',
                '& + .item-event-sub': {
                    fontSize: '12px',
                    whiteSpace: 'nowrap',
                    height: '18px',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    width: 'calc(100% - 22px)',
                    display: 'block',
                    marginTop: '-1px',
                }
            },

            '& .format-data': {
                fontSize: '12px',
                textTransform: 'capitalize',
                float: 'left',
                marginTop: '-1px'
            }
        }
    },
    eventLink: {
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
        width: '100%',
        transition: '.2s all ease',
        '&:hover, &:focus': {
            backgroundColor: alpha(theme.palette.secondary.main, .1),
        },
        color: "#606060"
    },
    icon: {
        order: 2,
        position: 'absolute',
        right: '0px',
        top: '0px',
        fontSize: '16px',
        paddingRight: '20px',
        paddingLeft: '20px', 
        height: '65px',
        cursor: 'pointer',
        '&:hover': {
            color: '#919191', 
        },
        '&:focus, &:active': {
            color: '#DC0028',
        },
    },
    anadirCalendario: {
        marginTop: '0px',
        color: '#606060',
        cursor: 'pointer',
        fontSize: '12px',
        fontWeight: 'bold',
        lineHeight: 'initial',
        position: 'absolute',
        right: '5px',
        top: '5px',
        '&>i': {
            fontSize: '30px',
            color: '#606060',
            '&:hover': {
                color: '#919191',
            },
            '&:focus': {
                color: '#DC0028',
            },
        },
        
    },
    menuContainerEvento:{
        '& .MuiPaper-rounded':{
             borderRadius: '0px',
             '& .MuiList-padding': {
                 paddingTop: '0px',
                 paddingBottom: '0px',
                 '& .MuiListItem-root': {
                     height: '30px',
                     borderBottom: '1px solid #d6d8d8',
                     fontSize: '12px',
                     cursor: 'pointer',
                 }
             }
        }
     }
}));

const CustomTooltip: any = withStyles({
    tooltip: {
      color: "#606060",
      backgroundColor: "#fff",
      border: "1px solid #606060",
      fontSize: "12px",
      fontFamily: "Catalana-sans",
      borderRadius: "0px",
    }
  })(Tooltip);


export function Evento(props: any): JSX.Element {
    
    const classes = useStyles()
    const { event }: Event = props
    const { events } = props
    const eventoCalendario = {
        titulo: event.Titulo,
        inicio: new Date(parseInt(event.FechaInicio.substr(6))),
        fin: !event.EventoDiario ? new Date(parseInt(event.FechaFin.substr(6))) : undefined,
        descripcion: event.DescripcionBreve
    };
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const handleClose = () => {
        setAnchorEl(null);
    };

    const fechaEfecto = new Date(parseInt(event.FechaInicio.substr(6)));
    const fechaFin = !event.EventoDiario ? new Date(parseInt(event.FechaFin.substr(6))) : null;
    const initMonth = fechaEfecto.toLocaleString('default', { month: 'short' }).substr(0, 3)
    const initDay = fechaEfecto.getDate()
    //const endDate = event.fechaFin.toLocaleString('default', { month: 'short' }).substr(0, 3)
    const formatData = new Intl.DateTimeFormat("es-ES", {
        weekday: "short",
        day: "numeric",
        month: "short",
        hour: "numeric",
        minute: "numeric"
    }).format(fechaEfecto)

    const formatDataFin = fechaFin ? new Intl.DateTimeFormat("es-ES", {
        weekday: "short",
        day: "numeric",
        month: "short",
        hour: "numeric",
        minute: "numeric"
    }).format(fechaFin) : '';

    const mostrarOpciones = (event: any) => {
        event.stopPropagation();
        setAnchorEl(event.currentTarget)
    };

    const generarArchivoIcs = () => {
        const enlaceDescarga = document.createElement('a');
        enlaceDescarga.href = generarEnlaceIcs(eventoCalendario);
        enlaceDescarga.download = `${eventoCalendario.titulo}.ics`;
        enlaceDescarga.click();
    };

    return (
        <li className={`${classes.itemEvent} events-${events}`} >
            <Menu
                id="basic-menu"
                className={classes.menuContainerEvento}
                anchorEl={anchorEl}
                open={open}
                onClick={handleClose}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                }}
            >
                <MenuItem onClick={() => abrirDetachedWindow(generarEnlaceGoogle(eventoCalendario))}>
                    <Typography variant='caption'>Google Calendar</Typography>
                </MenuItem>
                <MenuItem onClick={() => abrirDetachedWindow(generarEnlaceYahoo(eventoCalendario))}>
                    <Typography variant='caption'>Yahoo</Typography>
                </MenuItem>
                <MenuItem onClick={generarArchivoIcs}>
                    <Typography variant='caption'>Outlook</Typography>
                </MenuItem>
            </Menu>

            <Link className={classes.eventLink} to={event.UrlBase}>
                {
                    event.Destacada ?
                        <div className="item-event-date">
                            <span className="event-month event-color">{initMonth}</span>
                            <span className="event-day event-color">{initDay}</span>
                        </div>
                        :
                        <div className="item-event-date">
                            <span className="event-month">{initMonth}</span>
                            <span className="event-day">{initDay}</span>
                        </div>
                }
                <div className="item-event-content">
                    <div className="wrapper">
                    <CustomTooltip title={event.Titulo}>
                        <h3>{event.Titulo}</h3>
                    </CustomTooltip>
                    <CustomTooltip title={event.DescripcionBreve}>
                        <div title={event.DescripcionBreve}className="item-event-sub">{event.DescripcionBreve}</div>
                    </CustomTooltip>
                    </div>
                    <div className="wrapper">
                        {event.EventoDiario ?
                            <span className="format-data"> Todo el día</span> :
                            <React.Fragment>
                                <span className="format-data">De {formatData}</span>
                                <span className="format-data"> a {formatDataFin}</span>
                            </React.Fragment>
                        }
                    </div>
                </div>
            </Link>
            <Typography variant='caption' onClick={mostrarOpciones} className={classes.anadirCalendario}><i className='icon-calendario-reloj'></i></Typography>
        </li >
    )
}